{
  "verse": {
    "loading": "আয়াত লোড হচ্ছে...",
    "error": "আয়াত লোড করা যায়নি",
    "reference": "— সূরা {{surah}}, আয়াত {{ayah}}",
    "arabicUnavailable": "(আরবি উপলব্ধ নেই)",
    "english": "English",
    "arabic": "العربية",
    "swapLanguage_aria": "ভাষা পরিবর্তন করুন",
    "toggleLanguage_title": "ইংরেজি / আরবি টগল করুন",
    "reflect": "চিন্তা করুন",
    "reflecting": "ভাবছি…",
    "reflect_aria": "এই আয়াতকে আপনার নিয়তের সাথে যুক্ত করে একটি ব্যক্তিগত ভাবনা তৈরি করুন",
    "insights": "অন্তর্দৃষ্টি",
    "insights_aria": "AI কুরআন অন্তর্দৃষ্টি খুলুন",
    "share": "শেয়ার",
    "share_aria": "এই আয়াতটি একটি ছবি হিসেবে শেয়ার করুন",
    "share_title": "এই আয়াত শেয়ার করুন",
    "removeFromFavorites_aria": "প্রিয় থেকে সরান",
    "saveToFavorites_aria": "প্রিয়তে সংরক্ষণ করুন",
    "favoritesProLocked_aria": "প্রিয় একটি Pro বৈশিষ্ট্য",
    "favoritesUpgrade_aria": "প্রিয় সংরক্ষণ করতে আপগ্রেড করুন",
    "signInToSave": "প্রিয় সংরক্ষণ করতে সাইন ইন করুন।",
    "failedToUpdateFavorites": "প্রিয় আপডেট করা যায়নি",
    "couldNotReflect": "ভাবনা তৈরি করা যায়নি",
    "shareCaption": "\"{{text}}\"\n— সূরা {{surah}}, আয়াত {{ayah}}\n\nrhemn.com",
    "imageSavedVerseCopied": "ছবি সংরক্ষিত · আয়াত কপি হয়েছে",
    "imageSaved": "আয়াতের ছবি সংরক্ষিত হয়েছে",
    "couldNotCreateImage": "ছবি তৈরি করা যায়নি"
  },
  "insights": {
    "panel_aria": "কুরআন অন্তর্দৃষ্টি প্যানেল",
    "title": "অন্তর্দৃষ্টি",
    "reference": "সূরা {{surah}}, আয়াত {{ayah}}",
    "close_aria": "অন্তর্দৃষ্টি প্যানেল বন্ধ করুন",
    "versePreview_aria": "আয়াত প্রিভিউ",
    "back_aria": "ফিরে যান",
    "tryAgain": "আবার চেষ্টা করুন",
    "backTo_aria": "{{ref}}-এ ফিরে যান",
    "copyVerse_aria": "{{ref}} কপি করুন",
    "openingVerse": "আয়াতটি খোলা হচ্ছে…",
    "verseError": "আয়াতটি খোলা যায়নি।"
  },
  "proGate": {
    "title": "AI কুরআন অন্তর্দৃষ্টি একটি Pro বৈশিষ্ট্য",
    "subtitleSafari": "Unlock deep, contextual understanding of every verse with Rhemn Pro. Already a member? It unlocks automatically when you sign in.",
    "subtitle": "প্রতিটি আয়াতের গভীর, প্রাসঙ্গিক উপলব্ধি উন্মোচন করুন।",
    "bulletAsk": "আয়াত সম্পর্কে যেকোনো প্রশ্ন করুন",
    "bulletTafsir": "তাৎক্ষণিক AI-চালিত তাফসীর সারসংক্ষেপ",
    "bulletRelated": "বিষয়গতভাবে সম্পর্কিত আয়াত আবিষ্কার করুন",
    "upgrade": "Pro-তে আপগ্রেড করুন"
  },
  "ask": {
    "heading": "জিজ্ঞাসা করুন",
    "suggestion1": "এই আয়াতের বৃহত্তর প্রেক্ষাপট কী?",
    "suggestion2": "আমি কীভাবে এটি দৈনন্দিন জীবনে প্রয়োগ করতে পারি?",
    "suggestion3": "ধ্রুপদী আলেমগণ এ সম্পর্কে কী বলেন?",
    "placeholder": "এই আয়াত সম্পর্কে যেকোনো কিছু জিজ্ঞাসা করুন…",
    "input_aria": "এই আয়াত সম্পর্কে একটি প্রশ্ন করুন",
    "submit_aria": "প্রশ্ন জমা দিন",
    "submit_title": "জমা দিন (⌘↵)",
    "submit_label": "জিজ্ঞাসা করুন",
    "submit_hint": "⌘↵",
    "suggestions_aria": "প্রস্তাবিত প্রশ্ন",
    "error": "উত্তর পাওয়া যায়নি।",
    "pending": "আপনার প্রশ্ন নিয়ে ভাবা হচ্ছে…",
    "attribution": "AI-তৈরি উত্তর · যোগ্য আলেমদের জ্ঞানের বিকল্প নয়"
  },
  "tafsir": {
    "heading": "তাফসীর",
    "emptyText": "এই আয়াতের জন্য একটি AI-তৈরি তাফসীর সারসংক্ষেপ পান।",
    "generate": "তাফসীর তৈরি করুন",
    "commentary": "ব্যাখ্যা",
    "regenerate": "পুনরায় তৈরি করুন",
    "regenerate_aria": "তাফসীর পুনরায় তৈরি করুন",
    "attribution": "AI-তৈরি সারসংক্ষেপ · যোগ্য আলেমদের জ্ঞানের বিকল্প নয়",
    "error": "তাফসির তৈরি করা যায়নি।",
    "pending": "ব্যাখ্যা পড়া হচ্ছে…"
  },
  "related": {
    "heading": "সম্পর্কিত আয়াত",
    "copied": "কপি হয়েছে: {{ref}}",
    "failedToCopy": "কপি করা যায়নি",
    "empty": "কোনো সম্পর্কিত আয়াত পাওয়া যায়নি।",
    "error": "সম্পর্কিত আয়াত লোড করা যায়নি।",
    "pending": "সম্পর্কিত আয়াত খোঁজা হচ্ছে…"
  },
  "favorites": {
    "panel_aria": "প্রিয় আয়াত",
    "title": "প্রিয় আয়াত",
    "proLocked": "আয়াত প্রিয় তালিকা একটি Pro বৈশিষ্ট্য।",
    "loading": "লোড হচ্ছে…",
    "failedToLoad": "প্রিয় লোড করা যায়নি",
    "empty": "এখনও কোনো প্রিয় নেই। সংরক্ষণ করতে যেকোনো আয়াতের হৃদয়ে ট্যাপ করুন।",
    "reference": "— সূরা {{surah}}, আয়াত {{ayah}}",
    "remove_aria": "প্রিয় থেকে সরান",
    "failedToRemove": "সরানো যায়নি"
  }
}
